/**
 * Options for formatting numeric values.
 *
 * @param round - When true, rounds to the nearest integer before formatting. Default: false.
 */
export interface FormatNumberOptions {
  round?: boolean;
}

/**
 * Formats a number with locale-aware grouping (e.g. commas).
 *
 * @param value - The numeric value to format
 * @param options - Formatting options
 * @returns Formatted number string (e.g. "1,234" or "1,234.5")
 */
export const formatNumber = (
  value: number,
  options?: FormatNumberOptions
): string => {
  const num = options?.round ? Math.round(value) : value;
  return new Intl.NumberFormat('en-US').format(num);
};
